<template>
<!-- {{loadingWrapperPDF}}
{{urls}} -->
  <div class="render-container">
    <div class="layout-notify-container">
        <p class="layout-notify">Print it your way — new label layout options below.</p>
    </div>
    
    <div v-show="wrapperLabelPDF" class="label-choice-container">
        <div class="label-layout">
            <label for="layout">Label layout</label>
            <select class="input-container-input" id="layout" v-model="labelLayout">
                <option value="6x4">6x4 Label</option>
                <option value="top-left">Letter — Top Left</option>
                <option value="top-right">ULINE - Integrated 6x4</option>
                <option value="avery-94278">Avery 94278</option>
                <option value="envelope-10">Envelope #10</option>
            </select>
            <button v-if="labelLayout" @click="wrapManyToLetterAndOpen(this.urls, labelLayout)" class="get-label-button">Get Label</button>
        </div>
    </div>

    <div class="pdf-container">
        <div class="loading-overlay" v-if="loadingWrapperPDF">
            <loading-skeleton :loadingHeight="'300px'"/>
        </div>
        <embed v-show="wrapperLabelPDF" class="pdfViewer" id="pdfViewer" :src="wrapperLabelPDF" width="100%" height="500" javascript="allow" full-frame>
        <div v-show="wrapperLabelPDF" class="getLabelButton-container">
            <a class="getLabelButton" target="_blank" :href="wrapperLabelPDF">Open label in new tab</a>
        </div>
    </div>
  </div>
<AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>

</template>

<script>
import { PDFDocument, degrees } from 'pdf-lib'
import LoadingSkeleton from './LoadingSkeleton.vue';
import AlertUser from '../../components/Popups/AlertUser.vue';

export default {
    data(){
        return {
            wrapperLabelPDF: null,
            loadingWrapperPDF: false,
            labelLayout: null,
            toggleAlertBox: false,
            alertMessage: ""

        }
    },
    components:{
        AlertUser,
        LoadingSkeleton
    },
    async mounted(){
        let saved = null;
        try {
            saved = localStorage.getItem('defaultLabelLayout');
        } catch (e) {
            // storage might be blocked (Safari/iframe/incognito); fall back
            this.labelLayout = '6x4';
        }

        if (!saved || saved === 'null' || saved === 'undefined' || saved.trim() === '') {
            localStorage.setItem('defaultLabelLayout', '6x4');
            this.labelLayout = '6x4';
        } else {
            this.labelLayout = saved;
        }

        await this.wrapManyToLetterAndOpen(this.urls, this.labelLayout);
    },
    watch: {
        async urls(newVal) {
            if (newVal && newVal.length > 0) {
                await this.wrapManyToLetterAndOpen(newVal, this.labelLayout);
            }
        }
    },
    props:['urls'],
    methods:{
      async wrapManyToLetterAndOpen(urls, positionSide) {
            this.loadingWrapperPDF = true;
            this.wrapperLabelPDF = null;

            try {
                localStorage.setItem('defaultLabelLayout', positionSide);
                // Fetch all PDFs (CORS required on sources)
                // const buffers = await Promise.all(
                //     urls.map(u =>
                //         fetch(u, { mode: 'cors' }).then(r => {
                //         if (!r.ok) console.log(`Fetch failed (${r.status}) for ${u}`);
                //             return r.arrayBuffer();
                //         })
                //     )
                // );
                const results = await Promise.all(
                    urls.map(u =>
                        fetch(u, { mode: 'cors' })
                        .then(r => (r.ok ? r.arrayBuffer() : (console.warn(`Fetch failed (${r.status}) for ${u}`), null)))
                        .catch(err => (console.warn(`Fetch error for ${u}:`, err?.message || err), null))
                    )
                );

                // Keep only successful buffers
                const buffers = results.filter(Boolean);

                const out = await PDFDocument.create();

                if (positionSide === '6x4') {
                    for (const buf of buffers) {
                        const src = await PDFDocument.load(buf);
                        const indices = Array.from({ length: src.getPageCount() }, (_, i) => i);
                        const copied = await out.copyPages(src, indices);
                        copied.forEach(p => out.addPage(p));
                    }
                } else {
                const letterWidth = 612;  // 8.5 * 72
                const letterHeight = 792; // 11  * 72

                for (const buf of buffers) {
                    const src = await PDFDocument.load(buf);
                    const pageCount = src.getPageCount();

                    for (let i = 0; i < pageCount; i++) {
                        const [embedded] = await out.embedPages([src.getPage(i)]);
                        const { width: w, height: h } = embedded.scale(1);
                        let drawW = w;
                        let drawH = h;

                        if (positionSide === 'top-left') {
                            const page = out.addPage([letterWidth, letterHeight]);
                            page.drawPage(embedded, {
                            x: 0,
                            y: letterHeight - drawH,
                            width: drawW,
                            height: drawH
                            });
                        } else if (positionSide === 'top-right') {
                            const page = out.addPage([letterWidth, letterHeight]);
                            page.drawPage(embedded, {
                            x: letterWidth - drawW - 32,
                            y: letterHeight - drawH - 16,
                            width: drawW,
                            height: drawH
                            });
                        } else if (positionSide === 'avery-94278') {
                            const page = out.addPage([letterWidth, letterHeight]);
                            page.drawPage(embedded, {
                            x: letterWidth  - 90,
                            y: letterHeight - w - 96.7536,//letterHeight - 695.2464,
                            width: w,
                            height: h,
                            rotate: degrees(90)
                            });
                        }else if(positionSide === 'envelope-10'){
                            const envelopeW = 297;  // 9.5 * 72
                            const envelopeH = 684;  // 4.125 * 72

                            const page = out.addPage([envelopeW, envelopeH]);

                            // Natural size of the embedded source page (no scaling)
                            const { width: w, height: h } = embedded.scale(1);

                            // Place it TOP-CENTERED (no margins)
                            const x = (envelopeW - w) / 2;
                            const y = envelopeH - h;

                            page.drawPage(embedded, {
                            x,
                            y,
                            width: w,
                            height: h,
                            });
                        }
                    }
                    }
                }

                const bytes = await out.save();
                const blob = new Blob([bytes], { type: 'application/pdf' });
                const urlBlob = URL.createObjectURL(blob);
                this.wrapperLabelPDF = urlBlob;
            } catch (err) {
                this.toggleAlertBox = true;
                this.alertMessage = "Error generating shipment labels."
                console.error('wrapManyToLetterAndOpen error:', err?.message || err);
                this.wrapperLabelPDF = null;
            } finally {
                this.loadingWrapperPDF = false;
            }
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
            this.toggleCustomAddressWarning = toggleAlertBox;
            // this.showTermsConditions = toggleAlertBox;
        }
    }
}
</script>

<style scoped>
.layout-notify-container{
    display: flex;
    justify-content: center;
}
.layout-notify{
    width: fit-content;
    background-color: #e2e2e2;
    font-weight: bold;
    padding: 5px 15px;
    border-radius: 999px;
}

.label-choice-container{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 5px;
}

.label-layout{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.label-choice-container  label{
    margin-right: 5px;
    white-space: nowrap;
}

.input-container-input {
	padding: 10px;
	font-size: 15px;
	border: 1px solid rgba(0, 0, 0, .336);
	border-radius: 15px;
	outline: 0;
	margin-left: auto;
	width: 50%
}

.get-label-button{
    background-color: #33f18a;
	box-shadow: rgba(0, 0, 0, .068) 0 1px 5px;
	border-radius: 50px;
	cursor: pointer;
	transition-duration: .5s;
	border: none;
	color: #fff;
	margin-top: 5px;
	margin-bottom: 5px;
    margin-left: 5px;
	padding: 5px 5px 5px 5px;
	white-space: nowrap;
}

.get-label-button:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.pdf-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
}

.loading-overlay {
  /* position: absolute; */
  margin-bottom: 5px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.8); /* Light overlay effect */
  /* z-index: 10; */
}

.pdfViewer {
	border-radius: 15px;
	margin-bottom: 15px;
}

.getLabelButton-container {
	margin-bottom: 10px;
	width: 100%;
	display: flex;
	justify-content: flex-start
}

.getLabelButton:hover {
	background-color: #2bb2df;
	transition-duration: .5s
}

.getLabelButton {
	color: #fff;
	background-color: #32ccfe;
	border: none;
	border-radius: 5px;
	padding: 10px 35px;
	transition-duration: .4s ease;
	cursor: pointer;
	font-size: 12px
}
</style>